import { createContext, useCallback, useContext, useRef } from 'react';

const AdminLeaveContext = createContext({
  setGuard: () => {},
  confirmLeave: () => true,
});

export function AdminLeaveProvider({ children }) {
  const guardRef = useRef(null);

  const setGuard = useCallback((guard) => {
    guardRef.current = guard;
  }, []);

  const confirmLeave = useCallback(() => {
    if (typeof guardRef.current === 'function') {
      return guardRef.current();
    }
    return true;
  }, []);

  return (
    <AdminLeaveContext.Provider value={{ setGuard, confirmLeave }}>
      {children}
    </AdminLeaveContext.Provider>
  );
}

export function useAdminLeave() {
  return useContext(AdminLeaveContext);
}
